<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #dataServiceForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Schema Version*</label>
        <input class="form-control" type="text" name="schemaversion" [(ngModel)]="rowData.SCHEMA_VERSION" required>
        @if (dataServiceForm.form?.get('schemaversion')?.invalid && dataServiceForm.form?.get('schemaversion')?.touched) {
<span class="form-error-container">
          Schema version is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Return Type*</label>
        <input class="form-control" type="text" name="returntype" [(ngModel)]="rowData.RETURN_TYPE" required>
        @if (dataServiceForm.form?.get('returntype')?.invalid && dataServiceForm.form?.get('returntype')?.touched) {
<span class="form-error-container">
          Return type is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Schema Agency*</label>
        <input class="form-control" type="text" name="schemaagency" [(ngModel)]="rowData.SCHEMA_AGENCY" required>
        @if (dataServiceForm.form?.get('schemaagency')?.invalid && dataServiceForm.form?.get('schemaagency')?.touched) {
<span class="form-error-container">
          Schema agency is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Schema Root*</label>
        <input class="form-control" type="text" name="schemaroot" [(ngModel)]="rowData.SCHEMA_ROOT" required>
        @if (dataServiceForm.form?.get('schemaroot')?.invalid && dataServiceForm.form?.get('schemaroot')?.touched) {
<span class="form-error-container">
          Schema root is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Main Element*</label>
        <input class="form-control" type="text" name="mainelement" [(ngModel)]="rowData.MAIN_ELEMENT" required>
        @if (dataServiceForm.form?.get('mainelement')?.invalid && dataServiceForm.form?.get('mainelement')?.touched) {
<span class="form-error-container">
          Main element is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Namespace*</label>
        <input class="form-control" type="text" name="namesapace" [(ngModel)]="rowData.NAMESPACE" required>
        @if (dataServiceForm.form?.get('namesapace')?.invalid && dataServiceForm.form?.get('namesapace')?.touched) {
<span class="form-error-container">
          Namespace is required.
        </span>
}
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
